/* eslint-disable no-loop-func */
/* eslint-disable no-plusplus */
const tableToForm = {
  name: 'vx-marketingform',
  props: {},
  mixins: [],
  data() {
    return {
    };
  },
  methods: {

    // Parse a table cell and return a data object property
    ReadCell(cellEl) {
      if (cellEl) {
        if (cellEl.firstChild) {
          if (cellEl.innerHTML) {
            return cellEl.innerHTML;
          } else if (cellEl.firstChild.textContent) {
            return cellEl.firstChild.textContent;
          }
          return '';
        }
        return '';
      }
      return '';
    },

    // Parse a table row and return a data object
    parseRow(rowEl) {
      const rowConfig = {
        FieldName: '',
        Label: '',
        ariaLabel: '',
        PlaceholderText: '',
        Validations: '',
        CssClasses: '',
        Style: '',
        Type: '',
        DefaultValue: '',
        WrapperDiv: '',
        Indent: 0,
      };
      const cells = rowEl.querySelectorAll('td');
      if (cells.length <= 11) {
        const self = this;
        const rowConfigKeys = Object.keys(rowConfig);
        cells.forEach((cell, index) => { rowConfig[rowConfigKeys[index]] = self.ReadCell(cell); });
        const indent = this.ReadCell(cells[10]);

        if (indent) { rowConfig.Indent = parseInt(indent); } else { rowConfig.Indent = 0; }
        return rowConfig;
      }
      return null;
    },

    // Parse the rows of the table and return an array of data objects.
    parseTable(tblEl) {
      const self = this;
      const rows = [];
      console.log(this.$refs, 'refs==');
      tblEl.querySelectorAll('tr').forEach((e) => {
        const row = self.parseRow(e);
        if (row) { rows.push(row); }
      });
      return rows;
    },

    // Fix any copyright symbols which are not superscripted
    fixSuper(html) {
      let ret = html;
      while (html.indexOf('®') > -1 && html.indexOf('<sup>®') === -1) {
        ret = `${html.substr(0, html.indexOf('®'))}<sup>®</sup>${html.substring(html.indexOf('®') + 1)}`;
      }
      return ret;
    },

    // Renders a data object into an element
    RenderElement(cell, doc) {
      let wrapperEl =null;

      if (cell.WrapperDiv.length > 0) {
        wrapperEl = doc.createElement('div');
        wrapperEl.setAttribute('class', cell.WrapperDiv);
      }

      const newEl = doc.createElement(cell.Type);
      if (cell.CssClasses.length > 0) { newEl.setAttribute('class', cell.CssClasses); }
      if (cell.Style.length > 0) { newEl.setAttribute('style', cell.Style); }
      if (cell.ariaLabel.length > 0) { newEl.setAttribute('aria-label', cell.ariaLabel); }

      if (cell.Label.length > 0) { newEl.innerHTML = this.fixSuper(cell.Label); }

      if (wrapperEl) {
        wrapperEl.appendChild(newEl);
        return wrapperEl;
      }

      return newEl;
    },

    RenderInput(cell, doc) {
      let wrapperEl = null;
      console.log("cell.WrapperDiv",cell.WrapperDiv)
      console.log("cell.WrapperDiv.length",cell.WrapperDiv.length)

      if (cell.WrapperDiv.length > 0) {
        wrapperEl = doc.createElement('div');
        wrapperEl.setAttribute('class', cell.WrapperDiv);
      }
      const newEl = doc.createElement('input');
      newEl.setAttribute('type', cell.Type);
      if (cell.FieldName.length > 0) { newEl.setAttribute('name', cell.FieldName); }
      if (cell.PlaceholderText.length > 0) { newEl.setAttribute('placeholder', cell.PlaceholderText); }
      if (cell.CssClasses.length > 0) { newEl.setAttribute('class', cell.CssClasses); }
      if (cell.Style.length > 0) { newEl.setAttribute('style', cell.Style); }
      if (cell.ariaLabel.length > 0) { newEl.setAttribute('aria-label', cell.ariaLabel); }
      if (cell.Validations.length > 0) { newEl.setAttribute('validation', cell.Validations); }
      if (cell.DefaultValue.length > 0) { newEl.value = cell.DefaultValue; }
      if (wrapperEl) {
        wrapperEl.appendChild(newEl);
        return wrapperEl;
      }

      return newEl;

    },

    RenderButton(cell, doc) {
      let wrapperEl = null;
      console.log("cell.WrapperDiv",cell.WrapperDiv)
      console.log("cell.WrapperDiv.length",cell.WrapperDiv.length)
      if (cell.WrapperDiv.length > 0) {
        wrapperEl = doc.createElement('div');
        wrapperEl.setAttribute('class', cell.WrapperDiv);
      }
      const newEl = doc.createElement('input');
      newEl.setAttribute('type', cell.Type);
      if (cell.FieldName.length > 0) { newEl.setAttribute('name', cell.FieldName); }
      newEl.setAttribute('value', cell.FieldName);
      if (cell.PlaceholderText.length > 0) { newEl.setAttribute('placeholder', cell.PlaceholderText); }
      if (cell.CssClasses.length > 0) { newEl.setAttribute('class', cell.CssClasses); }
      if (cell.Style.length > 0) { newEl.setAttribute('style', cell.Style); }
      if (cell.ariaLabel.length > 0) { newEl.setAttribute('aria-label', cell.ariaLabel); }

      if (cell.Label.length > 0) { newEl.innerHTML = cell.Label; }

      if (wrapperEl) {
        wrapperEl.appendChild(newEl);
        return wrapperEl;
      }

      return newEl;
    },

    RenderOther(cell, doc) {
      let wrapperEl = null;

      if (cell.WrapperDiv.length > 0) {
        wrapperEl = doc.createElement('div');
        wrapperEl.setAttribute('class', cell.WrapperDiv);
      }
      console.log("cell.Type",cell.Type)
      if(cell.Type.length == 0){
        cell.Type ='div';
      }
        const newEl = doc.createElement(cell.Type);
        if (cell.CssClasses.length > 0) { newEl.setAttribute('class', cell.CssClasses); }
        if (cell.Style.length > 0) { newEl.setAttribute('style', cell.Style); }
        if (cell.ariaLabel.length > 0) { newEl.setAttribute('aria-label', cell.ariaLabel); }
        if (cell.DefaultValue.length > 0) { newEl.innerHTML = cell.DefaultValue; }
        if (wrapperEl) {
          wrapperEl.appendChild(newEl);
          return wrapperEl;
        }
        return newEl;

    },


    // TODO: Fix this to pull the correct spinner image
    RenderSpinner(parentEl) {
      const newSection = document.createElement('section');
      newSection.setAttribute('class', 'vx-spinner');
      const newSpinner = document.createElement('div');
      newSpinner.setAttribute('class', 'spinner-container fullscreen');
      newSpinner.setAttribute('style', 'display:none;');
      newSection.appendChild(newSpinner);

      const newImg = document.createElement('img');
      newImg.setAttribute('class', 'spinner');
      newImg.setAttribute('alt', 'Loading');
      newImg.setAttribute('src', '/_ui/responsive/common/dist/static/assets/images/spinner.gif');
      newImg.setAttribute('title', 'Loading');
      newSpinner.appendChild(newImg);

      parentEl.appendChild(newSection);
    },

    // Read the array which defines the form's HTML and write elements. Wraps everything in a div
    RenderTable(Rows) {
      const self = this;
       let parent = null;
       if (!parent) parent = document.createElement('div');

      const docFrag = document.implementation.createDocument('http://www.w3.org/1999/xhtml', null);
      //let parent = null; // This represents the element we are currently adding too.
      let newEl = null;
      let level = 0;
      let temp =null;
      for (let i = 1; i < Rows.length; i++) {
        if (Rows[i].Type.toLowerCase() === 'config') {
          self.config[Rows[i].FieldName] = Rows[i].DefaultValue;
        } else {
          //alert(Rows[i].Type.toLowerCase())
          console.log("indent",Rows[i].Indent,"level",level);
           switch (Rows[i].Type.toLowerCase()) {
            case 'div':
              newEl = self.RenderElement(Rows[i], docFrag);
              if (Rows[i].Indent > level) {
                level++;
                if (!parent.hasChildNodes()) {
                  parent.appendChild(newEl);
                } else if (!temp) {
                  temp = parent.lastChild.appendChild(newEl);
                } else {
                  if (!temp) temp = document.createElement('div');
                  temp.appendChild(newEl);
                }
              } else if (Rows[i].Indent === level) {
                if (!temp) temp = document.createElement('div');
                temp.appendChild(newEl);
              } else if (Rows[i].Indent < level) {
                level--;
                parent = parent.parentElement;
                parent.appendChild(newEl);
              } else {
                parent.appendChild(newEl);
              }
              break;
            case 'email':
            case 'text':
              parent.appendChild(self.RenderInput(Rows[i], docFrag));
              break;
            case 'hidden':
              if (Rows[i].FieldName.toLowerCase() === 'utm') {
                ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach((e) => {
                  const row = {};
                  for (const key in Rows[i]) {
                    row[key] = Rows[i][key];
                  }
                  row.FieldName = e;
                  parent.appendChild(self.RenderInput(row, docFrag));
                });
              } else {
                temp.appendChild(self.RenderInput(Rows[i], docFrag));
              }
              break;
            case 'button':
              parent.appendChild(self.RenderButton(Rows[i], docFrag));
              break;
            default:
              newEl = self.RenderOther(Rows[i], docFrag);
              if (Rows[i].Indent > level) {
                level++;
                parent = parent.appendChild(newEl);
              } else if (Rows[i].Indent < level) {
                level--;
                parent = parent.parentElement;
                parent.appendChild(newEl);
              } else {
                if (!parent) parent = document.createElement('div');
                parent.appendChild(newEl);
              }
              break;
          }
        }
      }
      return parent;
    },

    ParseTable(el) {
      let newEl;
      const tableRows = this.parseTable(el);
      if (tableRows && tableRows.length > 0) {
        newEl = this.RenderTable(tableRows);
      }
      return newEl
    },

    ParseTables(el) {
      let newEl;
      const self = this;
      el.querySelectorAll('.GPformDef').forEach((e) => {
        const _tableRows = self.parseTable(e);
        if (_tableRows && _tableRows.length > 0) {
          newEl = self.RenderTable(e, _tableRows);
        }
      });
      return newEl;
    },
  },
};

export default tableToForm;



// WEBPACK FOOTER //
// ./src/components/common/mixins/tableToForm-mixin.js